import React from 'react';
import styled from 'styled-components';

const EventsContainer = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
`;

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
`;

const EventItem = styled.div`
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
  &:last-child { border-bottom: none; }
`;

const mockEvents = [
  { id: 1, type: 'Lesson', desc: 'Photosynthesis - Grade 4', date: 'Tomorrow, 10:00 AM' },
  { id: 2, type: 'Assignment', desc: 'Heart Structure - Grade 7A', date: 'Due in 2 days' },
  { id: 3, type: 'School Event', desc: 'Science Fair', date: 'Friday, 1:00 PM' },
];

const UpcomingEvents: React.FC = () => (
  <EventsContainer>
    <Title>Upcoming Events</Title>
    {mockEvents.map(ev => (
      <EventItem key={ev.id}>
        <span style={{ fontWeight: 500, color: '#7c3aed', marginRight: 8 }}>{ev.type}:</span>
        {ev.desc} <span style={{ color: '#6b7280', fontSize: '0.85em', marginLeft: 8 }}>{ev.date}</span>
      </EventItem>
    ))}
  </EventsContainer>
);

export default UpcomingEvents; 